var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75099 9.00077H3.52266M3.44219 9.27294L1.2226 15.785C1.04823 16.2966 0.961045 16.5524 1.02361 16.7099C1.07795 16.8467 1.19465 16.9505 1.33865 16.9899C1.50447 17.0354 1.75492 16.9247 2.25583 16.7033L18.1418 9.68192C18.6307 9.46583 18.8752 9.35778 18.9508 9.20768C19.0164 9.07727 19.0164 8.92427 18.9508 8.79386C18.8752 8.64376 18.6307 8.53572 18.1418 8.31962L2.25029 1.29583C1.75089 1.07511 1.5012 0.964749 1.33554 1.01002C1.19168 1.04934 1.07499 1.15278 1.02046 1.28932C0.957683 1.44654 1.04394 1.70179 1.21645 2.21228L3.44281 8.80052C3.47244 8.8882 3.48725 8.93204 3.4931 8.97688C3.49829 9.01666 3.49824 9.05694 3.49294 9.09671C3.48698 9.14153 3.47205 9.18533 3.44219 9.27294Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.49d5836969b863bcbad1a99289c85f08.svg";
export { ForwardRef as ReactComponent };